import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { CONTEXTS } from 'figshelf-modules';
import { CircularProgress, Box } from '@mui/material';

const ProtectedRoute = ({ children, requireAuth = true }) => {
  const auth = useContext(CONTEXTS.AuthContext);
  const location = useLocation();

  // Show loading spinner while auth state is being determined
  if (auth.isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // If authentication is required and user is not signed in, redirect to login
  if (requireAuth && !auth.isSignedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user is signed in and trying to access login page, redirect to home
  if (!requireAuth && auth.isSignedIn) {
    return <Navigate to="/" replace />;
  }

  // User is authenticated and can access the protected route
  return children;
};

export default ProtectedRoute; 